module.exports = __webpack_public_path__ + "static/media/kiwi.f17203c9.jpg";